import { ZulageListEntryCheckbox } from './ZulageListEntryCheckbox';
import { ZulageCheckboxTableCell } from './ZulageCheckboxTableCell';
import { ZulageInputTableRow } from './ZulageInputTableRow';
import { ZulageListeEntryText } from './ZulageListeEntryText';
import { ZulageDisplayTableRow } from './ZulageDisplayTableRow';
import { ZulageDisplayList } from './ZulageDisplayList';
import { ZulageMobileDropdown } from './ZulageMobileDropdown';

const ZulagenEntry = {
    ListCheckbox: ZulageListEntryCheckbox,
    ListText: ZulageListeEntryText,
    Cell: ZulageCheckboxTableCell,
    Row: ZulageInputTableRow,
    DisplayRow: ZulageDisplayTableRow,
    DisplayList: ZulageDisplayList,
    MobileDropdown: ZulageMobileDropdown,
};

export { ZulagenEntry };
